import { all } from 'redux-saga/effects';

import country from './country';
import form from './form';
import init from './init';
import marketplace from './marketplace';

const allSagas: any = {
  ...init,
  ...form,
  ...marketplace,
  ...country,
};

export default function* rootSaga() {
  yield all(Object.values(allSagas).map((saga: any) => saga()));
}
